import React, { Component } from 'react';
import { toast } from "react-toastify";
import { detect } from 'detect-browser';
import withRouter from '../../../CommonComponents/WithRouter';
import { getRightsDetails, ugcAction } from '../../../../actions/ugcRightsAction';
import { getIPDetails } from '../../../../actions/loginActions';
import SocialGoogleLogin from '../../../Authorization/SocialAuth/GoogleLogin';
import UgcAssetAction from './Elements/UgcAssetAction';
import { GET_NETWORK_ICON, baseUrl, capitalizeFirstLetter, getInitialRoute, isAppleSafari, showAddAccountAlertNew } from '../../../../utils';
import { MediaBaseUrl } from '../../../../actions/api';
import { getTwitterCode, yammerCode, getVimeoCode, getFbCode, getInstaCode } from '../../../../utils/auth';
import { addFacebookAccount, getFacebookDetails, getAccountDetails, addInstaPersonalAccount } from '../../../Authorization/SocialAuth/connectSocialAcc';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';


const browser = detect();
const channel = isAppleSafari() ? window : new BroadcastChannel('connect');
class UgcRights extends Component {
    state = {
        responseData: null, authorized: null, locationData: null, isActive: false, isRequest: false
    }
    componentDidMount() {
        const { params } = this.props
        var self = this;
        getRightsDetails(params.requestId).then((response) => {
            self.setState({
                responseData: response.data.responseData
            })
        })
        getIPDetails().then((response) => {
            self.setState({ locationData: response.data })

        })
        channel.addEventListener("message", this.readAuthenticationCode);
    }
    onClickToSubmit = (action, referenceId, comment) => {
        const { params } = this.props
        const { locationData, isActive, authorized } = this.state;
        if (isActive && authorized && Object.keys(authorized).length > 0 && comment && String(comment).length > 0) {
            var browserName = ""
            var browserVersion = ""

            var city = ""
            var region = ""
            var country = ""
            var ip = ""
            var timezone = ""
            if (locationData && Object.keys(locationData).length > 0) {
                city = locationData.city
                region = locationData.region
                country = locationData.country
                ip = locationData.ip
                timezone = locationData.timezone
            }


            if (browser && Object.keys(browser)) {
                browserName = browser.name;
                browserVersion = browser.version
            }

            const data = {
                "action": action,
                "code": params.requestId,
                "referenceId": referenceId,
                "city": city,
                "region": region,
                "country": country,
                "browserName": browserName,
                "browserVersion": browserVersion,
                "ip": ip,
                "timezone": timezone,
                "comment": comment,
                "username": authorized.data[0].name ? authorized.data[0].name : authorized.data[0].id
            }
            this.setState({ isRequest: true })
            ugcAction(data).then((response) => {
                toast.success("UGC Request has been successfully submitted.")
                this.setState({ isRequest: false })
                setTimeout(() => window.location.reload(), 300)
            })
        }
        else {
            if (comment && String(comment).length == 0) {
                toast.error("Please add comment.")
            }
            else {
                toast.error("Please verify your account.")
            }
            this.setState({ isRequest: false })
        }
    }
    onUpdateData = (provider, data) => {
        const { responseData } = this.state
        if (data && Object.keys(data).length > 0 && responseData && Object.keys(responseData).length > 0 && responseData.assets[0].username && ((data.email == responseData.assets[0].username) || data.id == responseData.assets[0].username || data.sub == responseData.assets[0].username || data.name == responseData.assets[0].username)) {
            const details = [data];
            this.setState({ isActive: true, authorized: { provider, details } });
        } else {
            toast.error("Please make sure to connect the correct source account.");
        }
    }


    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        const { responseData } = this.state;
        var self = this;
        if (type == "get-rights") {
            if (responseData.assets[0].networkId == 3) {
                addFacebookAccount(data, networkId, (data) => {
                    getFacebookDetails({ access_token: data.token }).then((response) => {
                        const accountDetials = response.data;
                        var accountsData = [];
                        if (accountDetials && Object.keys(accountDetials).length > 0) {
                            accountsData.push({ id: accountDetials.id, name: accountDetials.name, access_token: data.token, picture: baseUrl(`icons/social-icons/${GET_NETWORK_ICON(responseData.assets[0].networkId)}.svg`) });
                        }
                        if (responseData.assets[0].username == accountDetials.name) {
                            self.setState({ access_token: data.token, socialData: accountDetials, accountsData, isActive: true, authorized: { provider: GET_NETWORK_ICON(responseData.assets[0].networkId), data: accountsData } })
                        } else {
                            toast.error("Please make sure to connect the correct source account.")
                        }
                    })
                })
            } else if (responseData.assets[0].networkId == 2 || responseData.assets[0].networkId == 18) {
                addInstaPersonalAccount(data, (data) => {
                    const token = data.token;
                    getAccountDetails(token, 2, getInitialRoute() == 'widget' ? 6 : 4, (response) => {
                        if (response && Object.keys(response).length > 0) {
                            const data = response;
                            var accountsData = [];
                            if (data && Object.keys(data).length > 0) {
                                accountsData.push({ id: data.id, name: data.username, picture: baseUrl(`icons/social-icons/${GET_NETWORK_ICON(responseData.assets[0].networkId)}.svg`) })
                            }
                            if (responseData.assets[0].username == data.username || responseData.assets[0].username == data.name || responseData.assets[0].username == data.id || responseData.assets[0].client_id == data.id || responseData.assets[0].id == data.id) {
                                self.setState({ access_token: token, socialData: data, accountsData, isActive: true, authorized: { provider: GET_NETWORK_ICON(responseData.assets[0].networkId), data: accountsData } })
                            } else {
                                toast.error("Please make sure to connect the correct source account.")
                            }
                        }
                    });
                })
            } else if (responseData.assets[0].networkId == 1) {
                const token = data;
                getAccountDetails(token, 1, getInitialRoute() == 'widget' ? 6 : 4, (response) => {
                    if (response && Object.keys(response).length > 0) {
                        const data = response;
                        var accountsData = [];
                        if (data && Object.keys(data).length > 0) {
                            accountsData.push({ id: data.id, name: data.username ? data.username : data.name, picture: baseUrl(`icons/social-icons/${GET_NETWORK_ICON(responseData.assets[0].networkId)}.svg`) })
                        }
                        if (responseData.assets[0].username == data.username || responseData.assets[0].username == data.name || responseData.assets[0].username == data.id || responseData.assets[0].client_id == data.id || responseData.assets[0].id == data.id) {
                            self.setState({ access_token: token, socialData: data, accountsData, isActive: true, authorized: { provider: GET_NETWORK_ICON(responseData.assets[0].networkId), data: accountsData } })
                        } else {
                            toast.error("Please make sure to connect the correct source account.")
                        }
                    }
                });
            } else if (responseData.assets[0].networkId == 8) {
                getAccountDetails(data, 8, getInitialRoute() == 'widget' ? 6 : 4, (response) => {
                    if (response && Object.keys(response).length > 0) {
                        const { user, access_token } = response;
                        var accountsData = [];

                        if (user && Object.keys(user).length > 0) {
                            const id = user.uri.split('/').pop();
                            const name = user.name;
                            accountsData.push({ id: id, name: name, picture: baseUrl(`icons/social-icons/${GET_NETWORK_ICON(responseData.assets[0].networkId)}.svg`) });

                            if (responseData.assets[0].username == name || responseData.assets[0].username == id || responseData.assets[0].client_id == id || responseData.assets[0].id == id) {
                                self.setState({ access_token: access_token, socialData: response, accountsData, isActive: true, authorized: { provider: GET_NETWORK_ICON(responseData.assets[0].networkId), data: accountsData } })
                            } else {
                                toast.error("Please make sure to connect the correct source account.")
                            }
                        }
                    }
                });
            }
        }
    }

    onClickSocialConnect = (data) => event => {
        if (data && Object.keys(data).length > 0) {
            if (data.networkId == 18) {
                data['networkId'] = 2;
            }
            showAddAccountAlertNew({ id: data.networkId, name: GET_NETWORK_ICON(data.networkId) }, "get-rights");
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { responseData, authorized, isActive, isRequest } = this.state;
        return responseData && Object.keys(responseData).length > 0 && responseData.assets[0] ? <>
            <div className="d-flex flex-column flex-column-fluid align-items-center justify-content-center w-100">
                <div className="bg-white border-bottom w-100">
                    <div className="container">
                        <div className="text-center w-100 f-center py-3">
                            <FontAwesomeIcon type={'solid'} icon={'shield-check'} iconClass={'fs-4 me-1 text-success'} />
                            <h2 className="m-0">UGC Request</h2>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className='row'>
                        <div className="offset-xxl-3 col-xxl-6 offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 py-5">
                            <div className="mb-6">
                                <div className="card rounded-1 mb-5 overflow-hidden">
                                    <div className="card-body d-flex align-items-center justify-content-between bg-light flex-lg-row flex-column">
                                        {responseData.assets[0] && responseData.assets[0].client_logo != "" ?
                                            <div className="ugc_logo_ block-center">
                                                <div className="d-flex flex-shrink-0 w-100px h-100px mb-3 mb-lg-0 me-0 me-lg-3">
                                                    {responseData.assets[0].client_logo ? <img className="object-center-contain" src={responseData.assets[0].client_logo} height={100} width={100} alt={'logo'} /> : null}
                                                </div>
                                            </div> : null}
                                        <div className="ugc_comment_">
                                            <p className="fs-9 fw-medium mb-0 text-center text-lg-start">
                                                {responseData.assets[0].custom_message}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    authorized && Object.keys(authorized).length > 0 && !isActive ? <span className="fs-6 mb-3 mb-sm-0 text-center text-sm-start text-danger">Kindly authorize your account to verify post ownership.</span> : null
                                }
                                {authorized == null ?
                                    <div className="card rounded-1 mb-5 overflow-hidden">
                                        <div className="card-body d-flex align-items-center justify-content-between flex-sm-row flex-column">
                                            <span className="fs-6 mb-3 mb-sm-0 text-center text-sm-start">Kindly authorize your account to verify post ownership.</span>
                                            <div className="block-center">
                                                <>{
                                                    responseData.assets[0].networkId == 7 ? <SocialGoogleLogin onUpdateData={this.onUpdateData} socialLogin={true}><button type="button" className="btn btn-primary" >
                                                        Verify Account
                                                    </button></SocialGoogleLogin> :
                                                        <button type="button" className="btn btn-primary" onClick={this.onClickSocialConnect(responseData.assets[0])}>
                                                            Verify Account
                                                        </button>
                                                }</>

                                            </div>
                                        </div>
                                    </div> : authorized && Object.keys(authorized).length > 0 && authorized.data.length > 0 ? <div className="mb-8">

                                        <button type="button" className="bg-white p-3 w-100 f-between mb-5 border-0">
                                            <div className="d-flex align-items-center flex-grow-1 me-3">
                                                <div className="rounded-circle flex-shrink-0 me-2 overflow-hidden bg-light p-2">
                                                    <img className="object-center-cover symbol-34 p-1" src={authorized.data[0].picture} srcSet={authorized.data[0].picture} height={34} width={34} alt="instagram" />
                                                </div>
                                                <div className="overflow-hidden">
                                                    <span className="fw-bolder text-dark text-ellipsis">@{authorized.data[0].name}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <span className="h-20px w-20px">
                                                    <img className="object-center-cover" src={baseUrl(`icons/social-icons/${authorized.provider}.svg`)} alt="" />
                                                </span>
                                            </div>
                                        </button>
                                    </div> : null}
                            </div>

                            <div className="mb-5 w-100 m-auto" style={{ maxWidth: 650 }}>
                                <div className="row justify-content-center">
                                    {
                                        responseData.assets.map((item, assetsIndex) => {
                                            return <div className="col-sm-6" key={assetsIndex}>
                                                <UgcAssetAction item={item} onClickToSubmit={this.onClickToSubmit} key={`ugc_post_${assetsIndex}`} isActive={isActive} isRequest={isRequest} />
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div className="mb-3 w-100">
                                <div className="card mb-5 overflow-hidden">
                                    <div className="card-header w-100 bg-light">
                                        <div className="d-flex justify-content-between flex-wrap align-items-center w-100">
                                            <h6 className="mb-0">Terms & Conditions</h6>
                                            <a href={responseData.assets[0].custom_terms && String(responseData.assets[0].custom_terms).length > 0 && String(responseData.assets[0].custom_terms).includes('https://') ? responseData.assets[0].custom_terms : `${MediaBaseUrl}document/Terms&ConditionsforuseofUGC.docx`} className="btn p-0 text-decoration-underline" download="" target='_blank'>
                                                <span className="text-right me-1">Terms & Conditions</span>
                                                <FontAwesomeIcon type={'regular'} icon={'arrow-down-to-bracket'} iconClass={'fs-6'} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </> : null
    }
}

export default withRouter(UgcRights);
